<template>
  <div style="border: 1px solid #D4D4D4; border-radius: 7px; margin: 5%; max-height: 120px"
       :class="['pThumb flex-col flex__center clickable margin-right-10']"
       @click="$emit('addSignature', signature)"
  >
    <div class="pBgThumb pBgThumb_TextImg parentTextStyle" >
      <p class=" textStyle"><img v-if="url !== null" :src="url" width="23%" height="19%"/>{{text}}</p>
    </div>
    <div style="margin-bottom: 10px" class="pIndex flex-row font-size__small font-weight__bold">
      <span class="titleTextTyle">
        {{ signatureTitle || "Thêm ảnh" }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["text", "title", "url"],
  data() {
    return {
      signature: {
        text: this.text,
        url: this.url
      },
      signatureTitle: this.url === null ? this.title : this.title + ' có dấu'
    };
  },

  methods: {
  },

  mounted() {
  }
};
</script>

<style scoped>
/*.textParentStyle{*/
/*  min-height: 20px;*/
/*  max-height: 20px;*/
/*}*/
.parentTextStyle{
  position: relative;
  overflow-x: hidden;
  width: 100%;
}
.textStyle{
  size: 17px;
  color:black;
  margin-top:10px;
  font:  normal 100 17px 'Times New Roman';
  overflow: hidden;
  max-height: 80px;
  width: 100%;
  text-overflow: ellipsis;
}
.pThumb .pBgThumb {
  background-size: inherit;
}

.titleTextTyle {
  color: var(--color-dark);
}

.pBgThumb_TextImg {
  height: 95px;
}

img {
  float: left;
  margin-right: 10px;
}

</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/pdf-lib-contents/clickableSignature.vue